export default "__VITE_ASSET___SR0EBb7__"